/* eslint formatjs/no-literal-string-in-jsx: "error" */
import React from "react"
import { Checkbox, Text, FlexContainer, CheckboxGroup, sizing, Stack } from "@carrotfertility/carotene"
import { useHistory } from "react-router-dom"
import { getProviderFinderSearchURL, ProviderFinderParam } from "../../utils/providerFinderSearchUrl"
import { useUserContext } from "../../context/UserContext"
import { FormattedMessage, useIntl } from "react-intl"
import carrotPartnerIndicator from "../../resources/images/carrot-partner-indicator.svg"

export function CarrotPartnerFilter(): JSX.Element {
  const history = useHistory()
  const intl = useIntl()

  const params = new URLSearchParams(history.location.search)
  const currentCarrotPartnerSelection =
    params.has(ProviderFinderParam.CarrotPartner) && params.get(ProviderFinderParam.CarrotPartner) === "true"
  const { companyCountryCode } = useUserContext()

  const filterByCarrotPartner = (value): void => {
    const newSearchURL = getProviderFinderSearchURL({
      searchLocation: params.get(ProviderFinderParam.Search),
      radiusInKm: params.get(ProviderFinderParam.RadiusInKm),
      companyCountryCode,
      locationDetails: {
        latitude: Number(params.get(ProviderFinderParam.Latitude)),
        longitude: Number(params.get(ProviderFinderParam.Longitude)),
        countryCode: params.get(ProviderFinderParam.Country),
        isBroadArea: false
      },
      carrotPartner: value.includes("carrotPartner"),
      providerType: params.get(ProviderFinderParam.ProviderType)
    })
    history.push({
      pathname: newSearchURL.pathname,
      search: newSearchURL.search
    })
  }

  return (
    <FlexContainer direction="column" background="white" maxWidth="296px" borderRadius="6px" padding="12px">
      {/* Using a CheckboxGroup to fix a Carotene bug with Checkboxes 
      PR with the comment for this Checkbox group issue is here: https://github.com/carrotfertility/carotene/issues/202*/}
      <CheckboxGroup
        name="carrotPartner"
        value={currentCarrotPartnerSelection ? ["carrotPartner"] : []}
        onChange={filterByCarrotPartner}
        aria-label={intl.formatMessage({ defaultMessage: "Select carrot partner type" })}
      >
        <Stack spacing={sizing.spacing.small}>
          <Checkbox
            value="carrotPartner"
            secondaryText={intl.formatMessage({
              defaultMessage: `Carrot partner providers offer exclusive benefits like lower negotiated rates`
            })}
          >
            <FlexContainer>
              <Text sx={{ lineHeight: "medium", marginRight: "tiny" }} weight="normal" size="medium">
                <FormattedMessage defaultMessage={`Carrot partners only`} />
              </Text>
              <img
                src={carrotPartnerIndicator}
                alt={intl.formatMessage({ defaultMessage: "Carrot Partner indicator" })}
              />
            </FlexContainer>
          </Checkbox>
        </Stack>
      </CheckboxGroup>
    </FlexContainer>
  )
}
